import Lookup from 'src/componentes/select-async';
import DesdobramentoList from 'src/paginas/desdobramento';

const Desdobramento = (props) => {
  return (
    <Lookup
      valueKey="id"
      labelKey="descricao"
      showSearch
      clearable={true}
      hierarchy={true}
      url="/DesdobramentoLookup"
      searchComponent={DesdobramentoList}
      {...props}
      data={{ ...props.data, viewListSearch: true }}
    />
  );
};

export default Desdobramento;
